import constants from "./constants";
import createAction from "sagas/createAction";

const actions = {
  GetAllAdsList: () => createAction(constants.GET_ALL_ADS_LIST),
  ChangeConnectedAds: (g_ads_id, fb_id) => createAction(constants.CHANGE_CONNECTED_ADS, { g_ads_id, fb_id }),
  ClearChangeConnectedAdsResult: () => createAction(constants.CLEAR_CHANGE_CONNECTED_ADS_RESULT, {}),
};

export default actions;
